import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    IMPORT_FINAL_DELIVERY_DETAILS: createAsyncActionConstants('IMPORT_FINAL_DELIVERY_DETAILS'),
    IMPORT_TRANSPORT_DETAILS: createAsyncActionConstants('IMPORT_TRANSPORT_DETAILS')
}